<template>
<div>
    <h1 class="mb-4 text-gray-500">Bilibili Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            How to use Bilibili Downloader
        </h2>
        <div class="mb-4">
            1. Go to Bilibili and copy the URL of the video you want to download.<br>
            2. Paste the URL into the input field above.<br>
            3. Click "Find media" to extract the video.<br>
            4. Once the video is found, click the download icon to start the download.
        </div>
    </el-card>

    <bilibili-faq></bilibili-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Bilibili Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Bilibili Downloader is a free tool that lets you download videos from Bilibili (bilibili.com) for offline viewing. Save your favorite anime, gaming videos, and more in original quality.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does Bilibili Downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Our Bilibili video downloader uses a Chrome extension to find and extract video URLs from Bilibili pages. Simply paste the video URL, and the extension will locate the downloadable media files for you.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Is Bilibili Downloader free to use?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, Bilibili Downloader is completely free to use. Simply install the Chrome extension and start downloading videos from Bilibili without any subscription fees.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'What video quality can I download from Bilibili?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'You can download Bilibili videos in various qualities including 720p, 1080p, and even higher resolutions when available. The downloader preserves the original quality of the uploaded video.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free Bilibili Downloader - Download Videos from Bilibili',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos from Bilibili for offline viewing using our free Chrome extension. Save anime, gaming videos, and more in HD quality.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'bilibili downloader, download bilibili videos, bilibili video downloader, free bilibili downloader, bilibili chrome extension'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/bilibili-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
        }
    }
}
</script>
